<template>
  <div>
    <div class="ds-grid">
      <div class="ds-grid__col">
        <h3 class="ds-heading ds-margin-bottom-24">
          {{ title }}
        </h3>
      </div>
    </div>
    <div class="ds-grid">
      <div
        v-for="(item, index) in submethods"
        :key="item.id"
        :class="[
          { 'ds-margin-top-48 ds-md-margin-top-0': index !== 0 },
          { 'ds-md-grid__col--3': submethods.length === 4 },
          { 'ds-md-grid__col--4': submethods.length === 3 },
          { 'ds-md-grid__col--6': submethods.length === 2 || submethods.length === 1 }
        ]"
        class="ds-grid__col ds-grid__col--12"
      >
        <img
          v-if="item.image"
          :src="item.image.original.src"
          :alt="item.image.original.name"
          class="image ds-margin-bottom-24"
        >
        <h4
          v-if="item.name"
          class="ds-heading-xsmall ds-margin-bottom-12"
        >
          {{ item.name }}
        </h4>
        <p
          v-if="item.shortDescription"
          class="ds-text ds-margin-bottom-12"
        >
          {{ item.shortDescription }}
        </p>
        <RichText
          v-if="item.description"
          :data="item.description"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  title: { type: String, required: false },
  submethods: { type: Array, required: false }
})
</script>
<script>
export default {
  name: 'PaymentMethodSubMethods',
}
</script>
<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';

.image {
  height: 52px;
  width: auto;
}

</style>
